
import { tagableMixin } from "~/mixins";

export default {
  mixins: [tagableMixin],

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
    priorityCampaign: { type: Object, default: () => {} },
  },

  computed: {
    tags() {
      return this.product?.tags ?? [];
    },
    quickship() {
      return this.selectedVariant?.quickship ?? false;
    },
    icons() {
      return {
        saleTagText: this.priorityCampaign?.saleTileTitle,
        saleTagBgColor: this.priorityCampaign?.saleColor ?? "",
        isExclusive: this.isExclusive,
        isReadyToShip: this.isReadyToShip,
        isCustomisable: this.isCustomisable,
        quickship: this.quickship,
      };
    },
    showIcons() {
      return Object.values(this.icons).filter(icon => icon != null).length > 1;
    },
  },
};
